import React, { useEffect, useState } from "react";
import "./Userregistration.css";

const STORAGE_KEY = "vendor_registration";

const emptyForm = {
  ownerName: "",
  operationType: "",
  companyName: "",
  businessPlan: "",
  businessVertical: "",
  website: "",
  phone: "",
  email: "",
  address: "",
  remarks: "",

  // BANK DETAILS
  bankHolderName: "",
  accountNumber: "",
  branchName: "",
  ifscCode: ""
};

const UserRegistrationPro = ({ onNext }) => {
  const [form, setForm] = useState(emptyForm);
  const [files, setFiles] = useState({});
  const [isEdit, setIsEdit] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      setForm(JSON.parse(saved));
      setIsEdit(false);
    }
  }, []);

  const handleChange = (e) => {
    if (!isEdit) return;
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    if (!isEdit) return;
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(form));
    alert("Data Saved Successfully");
    setIsEdit(false);

    // ✅ Move to next tab automatically
    if (onNext) onNext();
  };
  return (
    <div className="reg-page">
      {/* HEADER */}
      <div className="reg-header">
        <h1>USER REGISTRATION</h1>
        <p>Vendor business & compliance details</p>
      </div>

      <div className="reg-card">
        {!isEdit && (
          <div className="edit-bar">
            <button onClick={() => setIsEdit(true)}>EDIT</button>
          </div>
        )}

        {/* BUSINESS */}
        <Section title="BUSINESS DETAILS">
          <Input label="Owner Name" name="ownerName" value={form.ownerName} onChange={handleChange} disabled={!isEdit} />
          <Input label="Operation Type" name="operationType" value={form.operationType} onChange={handleChange} disabled={!isEdit} />
          <Input label="Company Name" name="companyName" value={form.companyName} onChange={handleChange} disabled={!isEdit} />

          <Select label="Business Plan" name="businessPlan" value={form.businessPlan}
            options={["BASIC", "STANDARD", "PREMIUM"]}
            onChange={handleChange} disabled={!isEdit}
          />

          <Select label="Business Vertical" name="businessVertical" value={form.businessVertical}
            options={["RETAIL", "IT", "SERVICE", "MANUFACTURING"]}
            onChange={handleChange} disabled={!isEdit}
          />

          <Input label="Website" name="website" value={form.website} onChange={handleChange} disabled={!isEdit} />
          <Input label="Phone No" name="phone" value={form.phone} onChange={handleChange} disabled={!isEdit} />
          <Input label="Email ID" name="email" value={form.email} onChange={handleChange} disabled={!isEdit} />
          <Input label="Address" name="address" value={form.address} onChange={handleChange} disabled={!isEdit} />
        </Section>

        {/* DOCUMENTS */}
        <Section title="DOCUMENT UPLOADS" upload>
          <File label="Aadhar Card" name="aadhar" onChange={handleFile} disabled={!isEdit} />
          <File label="PAN Card" name="pan" onChange={handleFile} disabled={!isEdit} />
          <File label="GST Certificate" name="gst" onChange={handleFile} disabled={!isEdit} />
          <File label="Trade License" name="trade" onChange={handleFile} disabled={!isEdit} />
          <div className="reg-file">
            <label>Upload Passbook</label>
            <input type="file" name="passbook" onChange={handleFile} disabled={!isEdit} />
            <span className={files.passbook ? "uploaded" : "pending"}>
              {files.passbook ? "File Status: Uploaded" : ""}
            </span>
          </div>
        </Section>

        {/* BANK DETAILS */}
        <Section title="BANK DETAILS" upload>
          <Input label="Holder Name" name="bankHolderName" value={form.bankHolderName} onChange={handleChange} disabled={!isEdit} />
          <Input label="Account Number" name="accountNumber" value={form.accountNumber} onChange={handleChange} disabled={!isEdit} />
          <Input label="Branch Name" name="branchName" value={form.branchName} onChange={handleChange} disabled={!isEdit} />
          <Input label="IFSC Code" name="ifscCode" value={form.ifscCode} onChange={handleChange} disabled={!isEdit} />

          
        </Section>

        {/* REMARKS */}
        <Section title="REMARKS">
          <textarea
            name="remarks"
            value={form.remarks}
            onChange={handleChange}
            disabled={!isEdit}
            placeholder="Enter remarks..."
          />
        </Section>

        {isEdit && (
          <div className="reg-actions">
           <button onClick={handleSubmit}>SUBMIT & NEXT</button>
          </div>
        )}
      </div>
    </div>
  );
};

/* ---------- Components ---------- */

const Section = ({ title, children, upload }) => (
  <div className={`reg-section ${upload ? "upload-bg" : ""}`}>
    <h3>{title}</h3>
    <div className="reg-grid">{children}</div>
  </div>
);

const Input = ({ label, ...props }) => (
  <div className="reg-field">
    <label>{label}</label>
    <input {...props} placeholder={`Enter ${label}`} />
  </div>
);

const Select = ({ label, options, ...props }) => (
  <div className="reg-field">
    <label>{label}</label>
    <select {...props}>
      <option value="">-- Select --</option>
      {options.map(op => (
        <option key={op} value={op}>{op}</option>
      ))}
    </select>
  </div>
);

const File = ({ label, ...props }) => (
  <div className="reg-file">
    <label>{label}</label>
    <input type="file" {...props} />
  </div>
);

export default UserRegistrationPro;